<template>
  <v-skeleton-loader v-if="!isLoaded" class="mx-auto" max-width="150" type="heading"></v-skeleton-loader>
  <v-container v-else>
    <v-expansion-panels flat multiple accordion>
      <v-expansion-panel>
        <v-expansion-panel-header class="box-title localisation-icon localisation_button">
          <v-icon class="localisation-icon">mdi-map-marker-outline</v-icon>Localisation
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- <SearchAutocomplete :setPlace="setPlace" :has_typed="has_typed" /> -->
          <div>
            <v-autocomplete
              v-model="autocomplete.model"
              :items="items"
              :loading="autocomplete.isLoading"
              :search-input.sync="search"
              hide-no-data
              class="search_auto_complete"
              outlined
              clearable
              hide-selected
              hide-details
              item-text="description"
              label="Ex: Paris, France"
              return-object
            ></v-autocomplete>
          </div>
          <p class="localisation_text">
            Indiquez une commune, un département, une région, ou bien France si
            le lieu est indifférent.
          </p>
          <p>Distance maximale (km):</p>
          <v-slider v-model="distance" min="5" max="150" thumb-label></v-slider>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-divider style="margin: 0px 15px" />
      <v-expansion-panel>
        <v-expansion-panel-header class="box-title">Pour quel loyer ?</v-expansion-panel-header>
        <v-expansion-panel-content id="loyer_slider_content">
          <v-range-slider
            @change="slider_change"
            v-model="loyer.range"
            :max="loyer.max"
            :min="loyer.min"
            step="10"
            color="#87EAF2"
            hide-details
            class="align-center"
          ></v-range-slider>
          <v-row>
            <v-col>
              <v-text-field
                :value="loyer.range[0]"
                class="mt-0 pt-0 loyer_input"
                hide-details
                single-line
                outlined
                type="number"
                append-icon="mdi-currency-eur"
                @change="$set(loyer.range, 0, $event)"
              ></v-text-field>
            </v-col>
            <!-- <v-col>
                    <v-divider class="mx-4" ></v-divider>
            </v-col>-->
            <v-col>
              <v-text-field
                :value="loyer.range[1]"
                class="mt-0 pt-0 loyer_input"
                hide-details
                single-line
                outlined
                type="number"
                append-icon="mdi-currency-eur"
                @change="$set(loyer.range, 1, $event)"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-select
            :items="['Par mois', 'Par an', 'Par m²/mois', 'Par m²/an']"
            v-model="loyer.type"
            dense
            outlined
          ></v-select>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-for="(item, i) in searchData" :key="i">
        <v-divider style="margin: 0px 15px" />
        <v-expansion-panel-header class="box-title">{{ item.name }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-for="i in item.data" :key="i.id" link style="padding: 0%; margin: 0%">
            <v-checkbox
              class="checkbox"
              color="#2CB1BC"
              v-model="searchCriteria"
              hide-details
              :label="i.name"
              :value="i.id"
            ></v-checkbox>
            <div v-if="i.description && i.description.length > 0" style="margin-left:42px">
              <p class="specify_filter_text">{{ i.description }}</p>
            </div>
          </div>
          <div v-if="item.id == 'type'">
            <v-checkbox
              class="checkbox"
              color="#2CB1BC"
              hide-details
              v-model="searchCriteria"
              label="Autre (merci de préciser)"
            ></v-checkbox>
            <div class="ml-4 mt-3">
              <v-text-field
                hide-details
                v-model="wished_type"
                label="Type de bien recherché"
                type="text"
                counter="25"
                clearable
                outlined
                :append-outer-icon="wished_type.length > 0 ? 'mdi-send' : ''"
                @click:append-outer="sendWishedType"
              ></v-text-field>
              <p class="specify_filter_text">
                Merci de préciser. Notre équipe fera tout pour vous proposer ce
                type d’usage dans une prochaine version.
              </p>
            </div>
          </div>
          <div v-else-if="item.id == 'environnement'">
            <v-checkbox
              class="checkbox"
              color="#2CB1BC"
              v-model="searchCriteria"
              label="Autre (merci de préciser)"
              hide-details
            ></v-checkbox>
            <div class="ml-4 mt-3">
              <v-text-field
                hide-details
                v-model="wished_env"
                label="Environnement recherché"
                type="text"
                counter="25"
                clearable
                outlined
                :append-outer-icon="wished_env.length > 0 ? 'mdi-send' : ''"
                @click:append-outer="sendWishedEnv"
              ></v-text-field>
              <p class="specify_filter_text">
                Merci de préciser. Notre équipe fera tout pour ajouter cet
                environnement dans une prochaine version.
              </p>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <div style="padding-top: 50px">
        <v-row justify="space-between" align="center" no-gutters>
          <v-col cols="12" lg="5">
            <Button
              :readonly="!can_reset"
              style="width: 100%"
              title="Réinitialiser"
              class="search-button mb-2"
              @click.native="resetMethod"
              color="error"
              sizeText="small_text"
            />
          </v-col>
          <v-col cols="12" lg="5">
            <Button
              style="width: 100%"
              title="Valider"
              class="search-button mb-2"
              @click.native="searchMethod"
              sizeText="small_text"
            />
          </v-col>
        </v-row>
      </div>
    </v-expansion-panels>
  </v-container>
</template>


<script>
import Button from "@/components/HomeSections/SubComponents/Button";
import send_suggestion from "@/services/suggestion";
import { mapGetters, mapActions } from "vuex";
import Vuex from "vuex";

import {
  NOT_LOGGED_IN,
  SUGGESTION_SUCCESS,
  INTERNAL_ERROR
} from "@/utils/snackbar_constants";

const searchCriteriaStore = new Vuex.Store({
  state: {
    searchCriteria: []
  }
});

export default {
  props: {},

  components: {
    Button
  },

  data: () => ({
    isLoaded: false,
    distance: 5,
    wished_env: "",
    wished_type: "",
    loyer: {
      type: "Par mois",
      min: 0,
      max: 100000,
      range: [0, 100000],
      tmp_a: "0",
      tmp_b: "100000"
    },
    autocomplete: {
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      model: ""
    },
    search: "",
    searchData: null
  }),

  computed: {
    ...mapGetters({
      haveUser: "userModule/haveUser",
      getBiens: "biensModule/getBiens",
      getData: "dataModule/getData",
      getSearchCriteria: "searchCriteriaModule/getSearchCriteria"
    }),

    searchCriteria: {
      set(val) {
        searchCriteriaStore.state.searchCriteria = val;
      },
      get() {
        return searchCriteriaStore.state.searchCriteria;
      }
    },

    isSearchCriteriaEmpty() {
      return this.searchCriteria.length == 0;
    },
    has_localisation_typed() {
      return this.search != null && this.search.length != 0;
    },
    has_loyer_typed() {
      return (
        this.loyer.range[0] > this.loyer.min ||
        this.loyer.range[1] < this.loyer.max
      );
    },
    can_reset() {
      if (
        this.isSearchCriteriaEmpty == false ||
        this.has_localisation_typed == true ||
        this.has_loyer_typed == true
      )
        return true;
      return false;
    },
    fields() {
      if (!this.autocomplete.model) return [];

      return Object.keys(this.autocomplete.model).map(key => {
        return {
          key,
          value: this.autocomplete.model[key] || "n/a"
        };
      });
    },
    items() {
      return this.autocomplete.entries.map(entry => {
        const Description =
          entry.description.length > this.descriptionLimit
            ? entry.description.slice(0, this.descriptionLimit) + "..."
            : entry.description;

        return Object.assign({}, entry, { Description });
      });
    }
  },

  methods: {
    ...mapActions({
      fetchBiens: "biensModule/fetchBiens",
      fetchData: "dataModule/fetchData",
      clearSearchCriteria: "searchCriteriaModule/clearSearchCriteria",
      addSearchCriteria: "searchCriteriaModule/addSearchCriteria",
      notify: "notificationModule/notify"
    }),
    resetPosition() {
      this.autocomplete.model = null;
      this.search = null;
      this.setPlace(undefined);
    },
    resetLoyer() {
      this.loyer.tmp_a = this.loyer.min;
      this.loyer.tmp_b = this.loyer.max;
      this.loyer.range = [this.loyer.min, this.loyer.max]
      
    },
    clearCriteria() {
      this.searchCriteria = [];
    },
    setPlace(place) {
      this.selectedPlace = place;
    },
    slider_change() {
      this.loyer.tmp_a = this.loyer.range[0];
      this.loyer.tmp_b = this.loyer.range[1];
    },
    verify_loyer_min() {
      let a = parseInt(this.loyer.tmp_a, 10);
      if (!a) a = this.loyer.min;
      if (a < this.loyer.min) a = this.loyer.min;
      this.loyer.tmp_a = a;
      let new_range = [a, this.loyer.range[1]];
      this.loyer.range = new_range;
    },
    verify_loyer_max() {
      let a = parseInt(this.loyer.tmp_b, 10);
      if (!a) a = this.loyer.max;
      if (a > this.loyer.max) a = this.loyer.max;
      this.loyer.tmp_b = a;
      let new_range = [this.loyer.range[0], a];
      this.loyer.range = new_range;
    },
    async fetchBiensMethod() {
      this.isBiensLoaded = false;
      var arg = {
        selected: this.searchCriteria,
        loyer: this.loyer.range,
        type: this.loyer.type,
        place: this.selectedPlace,
        distance: this.distance
      };
      await this.fetchBiens(arg).then(() => {
        this.nbFetch = this.getBiens.length;
      });
      this.isLoaded = true;
    },
    async fetchDataMethod() {
      this.isSearchDataLoaded = false;
      await this.fetchData().then(() => {
        this.searchData = this.getData;
      });
      this.isSearchDataLoaded = true;
    },
    async fetchAll() {
      await this.fetchDataMethod();
      await this.fetchBiensMethod();
    },
    searchMethod() {
      this.isBiensLoaded = false;
      this.fetchBiensMethod().then(() => {
        this.searchData = this.getData;
        this.isBiensLoaded = true;
      });
    },
    resetMethod() {
      this.clearCriteria();
      this.resetPosition();
      this.resetLoyer();
      this.searchMethod();
    },
    sendWishedType() {
      const msg = this.wished_type;
      this.sendWished(msg, "TYPE").then(() => {
        this.wished_type = "";
      });
    },
    sendWishedEnv() {
      const msg = this.wished_env;
      this.sendWished(msg, "ENV").then(() => {
        this.wished_env = "";
      });
    },
    async sendWished(msg, type) {
      console.log("Sending msg", msg, type);
      if (!this.haveUser) {
        this.notify(NOT_LOGGED_IN);
        return;
      }
      send_suggestion({ content: msg, type: type }).then(e => {
        if (e == true) {
          this.notify(SUGGESTION_SUCCESS);
        } else {
          this.notify(INTERNAL_ERROR);
        }
      });
      // Check if auth
      // Notify if not : must be log
      // else
      // Send to firebase
      // Notify that everything is good
    }
  },
  watch: {
    search() {
      if (this.autocomplete.isLoading) return;

      this.setPlace(this.autocomplete.model);

      this.autocomplete.isLoading = true;

      fetch(
        "https://us-central1-foncierpublic-ecd11.cloudfunctions.net/autocompleteMaps",
        { method: "POST", body: JSON.stringify({ place: this.search }) }
      )
        .then(res => res.json())
        .then(res => {
          this.autocomplete.entries = res.data.predictions;
        })
        .catch(err => {
          console.log("catched error:", err);
        })
        .finally(() => (this.autocomplete.isLoading = false));
    }
  },
  beforeMount() {
    if (this.$route.query.type != null) {
      this.fetchDataMethod();
      searchCriteriaStore.state.searchCriteria.push(
        `type.${this.$route.query.type}`
      );
      this.searchMethod();
    } else {
      this.fetchAll().then(() => {
        this.searchData = this.getData;
      });
    }
  }
};
</script>

<style scoped>
.search_auto_complete {
  color: #627d98;
  background: #ffffff;
}

.localisation_button {
  padding-left: 15px;
}

.mdi-map-marker-outline {
  flex: 0 !important;
}

.localisation_text {
  padding-top: 1em;
  font-weight: 100;
  font-size: 12px;
}

.specify_filter_text {
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #486581;
}

.box-title {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
}

.checkbox {
  size: 10%;
  padding: 0%;
  margin: 0% 5%;
}

.search-button {
  max-height: 50px;
  text-transform: none;
}

.box-title {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
}
</style>